import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBag3: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bag-3, luggage, suitcase, work"><path d="M21.25 20.25V6.75H2.75V20.25H21.25Z" stroke="currentColor" strokeWidth="1.5"/><path d="M7.75 6.75V2.75H16.25V6.75" stroke="currentColor" strokeWidth="1.5"/><path d="M3 11L12 13L21 11" stroke="currentColor" strokeWidth="1.5"/><path d="M12 12V13.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconBag3;
